import TextSimilarityUtil from 'util/TextSimilarityUtil'
import Util from 'util/util'

// Do auto grading for the given answer
// Return an object with:
// - isCorrect: true/false
// - hasSpellingErrors: true (optional)
// - closestCorrectAnswer: string (optional)
export function autoGrade(taskModel, givenAnswer) {

    const CASE_SENSITIVE_GRADING = 0;
    const CASE_INSENSITIVE_GRADING = 1;
    const TEXT_SIMILARITY_GRADING = 2;

    // Strictness should be one of these
    if (![CASE_SENSITIVE_GRADING, CASE_INSENSITIVE_GRADING, TEXT_SIMILARITY_GRADING]
        .includes(taskModel.get('task_info_json').options.gradingStrictness)) {
        return
    }

    // Normalize the given answer
    givenAnswer = Util.normalizeCharacters(givenAnswer, { removeNewLines: true })

    // Get all correct answers
    let correctAnswers
    if (taskModel.get('task_info_json').variants) {
        correctAnswers = _.map(taskModel.get('task_info_json').variants, ({text}) => {
            return Util.normalizeCharacters(text, { removeNewLines: true })
        })
    } else {
        correctAnswers = [ Util.stripTags(Util.normalizeCharacters(taskModel.get('task_info_json').answer, { removeNewLines: true })) ]
    }

    // If we are case sensitive, the exact answer should be present
    if (taskModel.get('task_info_json').options.gradingStrictness === CASE_SENSITIVE_GRADING) {
        if (correctAnswers.includes(givenAnswer)) {
            return { isCorrect: true }
        }

        return { isCorrect: false }
    }

    // Convert to lowercase
    const correctAnswersLowerCase = _.map(correctAnswers, (answer) => {
        return answer.toLowerCase()
    })
    givenAnswer = givenAnswer.toLowerCase()

    // If the correct answer is present, we are done
    if (correctAnswersLowerCase.includes(givenAnswer)) {
        return { isCorrect: true }
    }

    // If we do not allow spelling errors, the exact lowercase answer should be present
    if (taskModel.get('task_info_json').options.gradingStrictness === CASE_INSENSITIVE_GRADING) {
        return { isCorrect: false }
    }

    // Find the most similar correct answer
    let bestSimilarity = 0
    let closestCorrectAnswer = ''
    for (let i = 0; i < correctAnswersLowerCase.length; i++) {
        const similarity = TextSimilarityUtil.getTextSimilarity(givenAnswer, correctAnswersLowerCase[i])
        if (similarity > bestSimilarity) {
            bestSimilarity = similarity

            // Use the non-lowercase correct answer
            closestCorrectAnswer = correctAnswers[i]
        }
    }

    // The given answer is not similar enough
    if (bestSimilarity < 0.75) {
        return { isCorrect: false }
    }

    // The given answer is correct, but has spelling errors
    return {
        isCorrect: true,
        hasSpellingErrors: true,
        closestCorrectAnswer
    }

}
